import React from 'react';
export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.ReactNode;
  label?: string;
  variant?: 'default' | 'primary' | 'ghost';
  'data-id'?: string;
}
export function IconButton({
  icon,
  label,
  variant = 'default',
  className = '',
  'data-id': dataId,
  ...props
}: IconButtonProps) {
  const variantStyles = {
    default: 'bg-white border border-[#CBD5E1] text-[#475569] hover:bg-[#F1F5F9]',
    primary: 'bg-[#0EA5E9] text-white hover:bg-[#0284C7]',
    ghost: 'bg-transparent text-[#475569] hover:bg-[#F1F5F9]'
  };
  return <button className={`
        p-2 rounded-md transition-all duration-200
        focus:outline-none focus:ring-2 focus:ring-[#0EA5E9] focus:ring-opacity-20
        disabled:opacity-50 disabled:cursor-not-allowed
        ${variantStyles[variant]}
        ${className}
      `} aria-label={label} {...props} data-id="element-3294">
      {icon}
    </button>;
}